import { MAX_SELECTED_LENGTH } from 'components/StoreSelector/hooks/useStoreSelector';
import { StoreSelectorValue } from 'components/StoreSelector/interface';
import { useFollowedStoreListState } from 'hooks/business/conversation';
import { useCallback } from 'react';
import { searchStoreList } from 'services/api/store';

function useGetStoreIdList() {
  const followedStoreList = useFollowedStoreListState();

  const getStoreIdList = useCallback(
    (storeValue: StoreSelectorValue, platform: General.PlatformUpperCase) => {
      const { region, follower, storeList } = storeValue;

      if (region) {
        return Promise.resolve(undefined);
      }

      if (storeList && storeList.length) {
        return Promise.resolve(storeList.map(({ storeId }) => storeId));
      }

      if (follower !== '1') {
        return Promise.resolve(undefined);
      }

      if (followedStoreList.length) {
        const storeIdList = followedStoreList.reduce<string[]>((res, store) => {
          const { externalType, storeId } = store;

          if (externalType === platform) {
            res.push(storeId);
          }

          return res;
        }, []);

        return Promise.resolve(storeIdList);
      }

      return searchStoreList({
        follower: '1',
        platform,
        cursor: 0,
        page_size: MAX_SELECTED_LENGTH,
      }).then((res) => {
        return res.data.data.data.map((store) => store.storeId);
      });
    },
    [followedStoreList],
  );

  return getStoreIdList;
}

export default useGetStoreIdList;
